import React from 'react'
import { IconButtonLink } from '@components/foundation/icon-button/IconButton'
import { ProgressBar } from '@components/foundation/progress-bar/ProgressBar'
import { ViewNavigationUtil } from '@utils/viewNavigationUtil'
import { useAppDrawerState } from '../hooks/useAppDrawerState'
import styles from '../styles/DrawerTopHeader.module.scss'

type DrawerTopHeaderProps = {
  onNavigateBack?: () => void
}

export const DrawerTopHeader: React.FC<DrawerTopHeaderProps> = props => {
  const { onNavigateBack } = props
  const { activeStep, hideNavigateBack, showProgress } = useAppDrawerState()

  const { showSteps, maxSteps } = ViewNavigationUtil.getStepConfig()
  const renderProgress = showSteps && showProgress

  return (
    <div className={styles.container}>
      {renderProgress && <ProgressBar maxSteps={maxSteps} step={activeStep} className={styles.progressNoNav} />}

      <div className={styles.progressWithNav}>
        {renderProgress && (
          <IconButtonLink
            className={styles.backButton}
            iconProps={{ name: 'arrow-left' }}
            disabled={hideNavigateBack}
            onClick={() => onNavigateBack?.()}
          />
        )}
        {renderProgress && <ProgressBar maxSteps={maxSteps} step={activeStep} className={styles.progressBar} />}
      </div>
    </div>
  )
}
